import { Link } from 'react-router-dom'

import { ApprovalListItem } from 'api/types'
import { useRegion } from 'components/app-shell/context/RegionContext'
import { formatDateTime, formatNumber } from 'lib/format'
import { tx } from 'lib/i18n'

import { Icon, IconName } from './Icon'
import { Button } from './ui'

const initials = (name?: string | null) =>
  (name || '')
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toUpperCase() || '؟'

const KpiChip = ({ icon, value, label }: { icon: IconName; value: number; label: string }) => (
  <span className="kpi-chip">
    <Icon name={icon} size={14} />
    <strong>{formatNumber(value)}</strong>
    {label}
  </span>
)

/** Dashboard approval card for a submitted report (Figma ApprovalCard, Web Platform component set). */
export const ApprovalCard = ({
  item,
  busy,
  onReturn,
  onApprove,
}: {
  item: ApprovalListItem
  busy?: boolean
  onReturn: (item: ApprovalListItem) => void
  onApprove: (item: ApprovalListItem) => void
}) => {
  const { locale } = useRegion()
  return (
  <article className="approval-card">
    <header className="approval-card__head">
      <span className="approval-card__avatar">{initials(item.preparedByName)}</span>
      <div className="approval-card__who">
        <p className="approval-card__name">{item.preparedByName || '—'}</p>
        <p className="muted small">{item.projectName}</p>
      </div>
      {item.submittedAt ? <span className="muted small approval-card__time">{formatDateTime(item.submittedAt)}</span> : null}
    </header>

    <div className="approval-card__meta">
      <Link to={`/projects/${item.projectId}/reports/${item.id}`} className="code-link">
        {item.code}
      </Link>
      <span className="chip chip--info">{tx(locale, 'بانتظار الاعتماد', 'Waiting for approval')}</span>
    </div>

    <div className="approval-card__kpis">
      <KpiChip icon="users" value={item.staffCount} label={tx(locale, 'عامل', 'workers')} />
      <KpiChip icon="truck" value={item.equipmentCount} label={tx(locale, 'معدة', 'equipment')} />
    </div>

    <div className="approval-card__actions">
      <Button size="sm" icon="undo" disabled={busy} onClick={() => onReturn(item)}>
        {tx(locale, 'إرسال للمراجعة', 'Send for review')}
      </Button>
      <Button size="sm" variant="success" icon="check" disabled={busy} onClick={() => onApprove(item)}>
        {tx(locale, 'اعتماد', 'Approve')}
      </Button>
    </div>
  </article>
  )
}
